<template>
  <div>
    <el-dialog
      :visible.sync="viewDialogVisible"
      :modal-append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="800px"
      class="bullet-detail"
      :title="$lang('运单主子表查询页')"
    >
      <div class="dialog-content">
        <jms-table
          :option="listOpt"
          :data="tableList"
          :page="page"
          :table-loading="loading"
          @row-del="rowDel"
          @size-change="sizeChange"
          @selection-change="selectionChange"
          @current-change="currentChange"
          :tablePageVisible="false"
        />
      </div>
    </el-dialog>
  </div>
</template>
<script>
import mixin from '@/mixins/mixin.js'

export default {
  name: 'WaybillLog',
  mixins: [mixin],
  data () {
    return {
      viewDialogVisible: false,
      isShowFirst: false,
      COM_HTTP: {
        reqList: this.$API_F.querySubNoList,
      },
      waybillNo: ''
    }
  },
  computed: {
    listOpt () {
      return {
        border: true,
        menu: false,
        viewBtn: false,
        editBtn: false,
        delBtn: false,
        // rowKey: '$index',
        index: true,
        fixHeight: 90,
        column: [
          {
            label: '子单号',
            prop: 'waybillSubNo',
            width: 350,
          },
          {
            label: '关联主单号',
            prop: 'waybillNo',
            width: 350,
          }
        ]
      }
    }
  },
  created () {
  },
  methods: {
    showDialog (waybillNo) {
      this.viewDialogVisible = true
      if (waybillNo) {
        this.waybillNo = waybillNo
        this.searchFun(1)
      }
    },
    hideDialog () {
      this.viewDialogVisible = false
    },
    getParams () {
      return {
        pageSize: 9999,
        waybillNo: this.waybillNo
      }
    },
  }
}
</script>
<style lang="scss">
.el-dialog__wrapper.bullet-detail {
  .el-dialog {
    margin-bottom: 0 !important;
    .el-dialog__body {
      max-height: 700px;
      overflow: auto;
    }
  }
  .el-dialog__footer {
    padding: 0;
    margin: 10px 20px 20px;
  }
}
</style>
